import {Component, inject, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AppInputComponent} from '@shared/components/forms/app-input/app-input.component';
import {AppSelectComponent} from '@shared/components/forms/app-select/app-select.component';
import {AppSwitchComponent} from '@shared/components/forms/app-switch/app-switch.component';
import {User, UserProfile, UsersApiService, UserStatus} from '@core/services/api/users-api.service';
import {AlertService} from '@core/services/alert.service';
import {ReactiveFormAbstract} from '@shared/commons/reactive-form-abstract.utils';

@Component({
    selector: 'app-user-modal',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        AppInputComponent,
        AppSelectComponent,
        AppSwitchComponent
    ],
    templateUrl: './user-register-dialog.component.html',
    styleUrl: './user-register-dialog.component.scss'
})
export class UserRegisterDialogComponent extends ReactiveFormAbstract implements OnInit {
    @Input() user?: User;
    @Input() isEditMode = false;

    public activeModal = inject(NgbActiveModal);
    private usersApiService = inject(UsersApiService);
    private alertService = inject(AlertService);

    profileOptions = [
        {value: UserProfile.ADMIN, label: 'Administrador'},
        {value: UserProfile.PROFESSIONAL, label: 'Profissional'}
    ];

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.form = this.createForm();

        if (this.isEditMode && this.user) {
            this.populateForm();
        }
    }

    protected createForm(): FormGroup {
        const form = this.fb.group({
            firstName: ['', [Validators.required, Validators.minLength(2)]],
            lastName: ['', [Validators.required, Validators.minLength(2)]],
            email: ['', [Validators.required, Validators.email]],
            password: [''],
            profile: [null, Validators.required],
            status: [true]
        });

        // Senha obrigatória apenas no modo criação
        if (!this.isEditMode) {
            form.get('password')?.setValidators([Validators.required, Validators.minLength(6)]);
        }

        return form;
    }

    private populateForm(): void {
        if (!this.user) return;

        this.patchValue({
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            email: this.user.email,
            profile: this.user.profile,
            status: this.user.status === UserStatus.ACTIVE
        });
    }

    protected submit(): void {
        this.loading = true;

        const formValue = this.form.value;
        const userData: User = {
            firstName: formValue.firstName,
            lastName: formValue.lastName,
            email: formValue.email,
            profile: formValue.profile,
            status: formValue.status ? UserStatus.ACTIVE : UserStatus.INACTIVE
        };

        // Incluir senha apenas se foi preenchida
        if (formValue.password) {
            userData.password = formValue.password;
        }

        const request$ = this.isEditMode && this.user?.id
            ? this.usersApiService.update(this.user.id, userData)
            : this.usersApiService.create(userData);

        request$.subscribe({
            next: (response) => {
                this.alertService.successfulOperation();
                this.activeModal.close(response.data);
            },
            error: () => {
                this.alertService.operationFailure();
                this.loading = false;
            }
        });
    }
}

